




























import { defineComponent } from '@nuxtjs/composition-api';
import { SfCarousel, SfCarouselItem } from '~/components/StorefrontUi';

export default defineComponent({
  components: { SfCarousel, SfCarouselItem },
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {};
  },
});
